if (process.env.NODE_ENV === 'production') {
  module.exports = require('./react-unique-id.production.js');
} else {
  module.exports = require('./react-unique-id.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@team-griffin/react-unique-id/dist/es/react-unique-id.js
// module id = 1377
// module chunks = 0